import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from './hooks/useAuth';

import LoginForm from './components/UI/LoginForm';
import { LoginFormData } from './types/authTypes';

const LoginPage: React.FC = () => {
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (loginData: LoginFormData) => {
    const result = await login(loginData);
    if (result.success) {
      navigate('/users');
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-[38.25rem] rounded-lg border border-[#ddd] bg-white p-16 text-center">
        <div className="mb-16">
          <img
            src="/img/logo_b2b.svg"
            alt="K-MONSTAR B2B Logo"
            className="mx-auto max-h-[28rem] w-[280px]"
          />
        </div>

        {error && (
          <div className="mb-6 rounded border border-red-300 bg-red-100 p-3 text-sm text-red-700">
            {error}
          </div>
        )}

        <LoginForm onSubmit={handleLogin} loading={loading} />
      </div>
    </div>
  );
};

export default LoginPage;
